var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.MallClassifySpecService}},[_c('TableText',{attrs:{"prop":"display_name","label":"规格","width":120}}),(_vm._isAdminPlatform)?_c('TableText',{attrs:{"prop":"enterprise.display_name","label":"所属企业","width":160}}):_vm._e(),_c('TableAction',{attrs:{"buttons":[
    { name: '参数配置', onClick: _vm.handleOption },
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":160}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }